module.exports = __webpack_public_path__ + "static/media/se.ef78e9ca.png";